import React from 'react';
import last from 'lodash.last';
import PropTypes from 'prop-types';
import { notIncludedInScore } from '../../../../utils/shared/probeDetailUtils';
import OralReadingWord from './OralReadingWord';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const SkippedRow = ({ row, lastSelectedItem }) => (
    <span
        className={
            notIncludedInScore(last(row).index, lastSelectedItem)
                ? 'line-trough'
                : 'line-trough-red'
        }
    >
        {row.map((wordObject, index) => (
            <OralReadingWord key={generateReactKey(index)} word={wordObject.word} />
        ))}
    </span>
);

SkippedRow.propTypes = {
    row: PropTypes.array.isRequired,
    lastSelectedItem: PropTypes.number.isRequired,
};

export default SkippedRow;
